export type UserGroupsState = {
  readonly isFetching: boolean
  readonly items: IdIndexedUserGroups
}

export type UserGroup = {
  readonly id: number
  readonly name: string
  readonly logoUrl?: string
  readonly websiteUrl?: string
}

export type UserGroupData = Omit<UserGroup, 'id'>

export type IdIndexedUserGroups = {
  readonly [userGroupId: number]: UserGroup
}

export const USER_GROUPS_STORE_ID = 'userGroups'
